import { FC, useState, useEffect } from 'react';
import { Link, useHistory } from "react-router-dom";

import { InputContact } from 'components';

import * as API from 'api';
import * as Meta from 'meta';
import { ROUTE } from 'route';
import { gaEvent } from "utils";
import { Header, Footer } from "components";
import * as Type from 'components/InputContact/type';

export const YouLosePage: FC = () => {
  const history = useHistory();
  const [isLoser, setIsLoser] = useState(null);
  const [haveFilled, setHaveFilled] = useState(false);

  useEffect(() => {
    fetch(API.haveTicket())
      .then(res => res.json())
      .then(haveTicket => {
        if(!haveTicket) history.push(ROUTE.HOME);
      });

    fetch(API.loser(true))
      .then(res => res.json())
      .then(setIsLoser);
  }, []);

  const postContact = (data: Type.IContactData) => {
    gaEvent('未中獎', '送出資料');
    fetch(API.loser(), {
      method: 'POST',
      headers: {'content-type': 'application/json'},
      body: JSON.stringify(data)
    }).then(res => res.json()).then(json => {
      if(json.errors) return alert("error");
      setHaveFilled(true);
    });
  };

  return (
    <div className="wrapper">
      {Meta.loadCSS(['success', 'notice'])}
      {Meta.loadJS(['main-0625'])}
      {Meta.ga("未中獎結果頁")}
      <Header />
      <div className="main">
        <section className="success inner">
          <div className="success_box">
            <div className="page_text">爽勁不夠 再接再厲<br />就只差那麼一點點爽</div>
            <div className="success_pic">
              <div className="success_prize ms"><img src="/resources/html/images/intro/songbeer.png" /></div>
            </div>
            <div className="success_sorry mt">
              <p>別放棄...還有<br />最爽好禮週週抽</p>
            </div>
            <div className="success_sorryprize">
              <div className="sorry_pic mp">
                <img src="/resources/html/images/success/s1.png" />
              </div>
              <div className="sorry_pic mp">
                <img src="/resources/html/images/success/s2.png" />
              </div>
              <div className="sorry_pic mp">
                <img src="/resources/html/images/success/s3.png" />
              </div>
              <div className="sorry_pic mp">
                <img src="/resources/html/images/success/s4.png" />
              </div>
            </div>
          </div>
          <img className="success_left" src="/resources/html/images/intro/intro_left.png" />
          <img className="success_right" src="/resources/html/images/intro/intro_right.png" />
        </section>
        <section className="success_form">
          {isLoser === null ? null:
            haveFilled || isLoser ?
              <div className="success_change inner">
                <div className="change_title">已收到您的資料</div>
                <div className="change_pic2"><img src="/resources/html/images/success/p2.png" /></div>
                <div className="change_in">相信下次一定可以</div>
                <div className="success_btbox">
                  <Link to={ROUTE.SCAN} onClick={gaEvent.bind(null, '未中獎', '繼續掃描')}><div className="success_b">繼續掃描QRcode</div></Link>
                </div>
              </div>:
              <InputContact func={postContact}/>
          }
        </section>
        <div className="fwave fw1 ml"><img src="/resources/html/images/login/wave01.png" /></div>
        <div className="fwave fw2 mr"><img src="/resources/html/images/login/wave02.png" /></div>
        <div className="fwave fw3 ml"><img src="/resources/html/images/login/wave03.png" /></div>
        <div className="fwave fw4 mr"><img src="/resources/html/images/login/wave04.png" /></div>
      </div>
      <Footer />
      <div className="scroll_top"><span>TOP</span></div>
    </div>
  );
};
